module.exports = __webpack_public_path__ + "img/hands_raised.b9777901.png";